import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

export default function Guides() {
  const canonical = 'https://earnmyedge.com/sales-guides';
  const itemListLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, url: 'https://earnmyedge.com/sales-training' },
      { '@type': 'ListItem', position: 2, url: 'https://earnmyedge.com/ai-sales-coach' },
      { '@type': 'ListItem', position: 3, url: 'https://earnmyedge.com/objection-handling-training' },
      { '@type': 'ListItem', position: 4, url: 'https://earnmyedge.com/sales-frameworks' },
      { '@type': 'ListItem', position: 5, url: 'https://earnmyedge.com/sales-roleplay-scenarios' }
    ]
  };

  return (
    <main className="mx-auto max-w-4xl px-6 py-12">
      <Helmet>
        <title>Sales Guides & Resources | Earn My Edge</title>
        <meta name="description" content="Curated sales guides covering training, AI coaching, objection handling, frameworks, and roleplay scenarios." />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content="Sales Guides & Resources | Earn My Edge" />
        <meta property="og:description" content="Curated sales guides covering training, AI coaching, objection handling, frameworks, and roleplay scenarios." />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content="/assets/social-card.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sales Guides & Resources | Earn My Edge" />
        <meta name="twitter:description" content="Curated sales guides covering training, AI coaching, objection handling, frameworks, and roleplay scenarios." />
        <meta name="twitter:image" content="/assets/social-card.png" />
        <script type="application/ld+json">{JSON.stringify(itemListLd)}</script>
      </Helmet>

      <header className="mb-8">
        <h1 className="text-3xl font-semibold">Sales Guides & Resources</h1>
        <p className="mt-4 text-muted-foreground">Start with these cornerstone pages to build skill and confidence fast.</p>
      </header>

      <section className="grid gap-6 sm:grid-cols-2">
        {[
          { title: 'Sales Training', href: '/sales-training', desc: 'Daily drills, coaching, and mastery tracking.' },
          { title: 'AI Sales Coach', href: '/ai-sales-coach', desc: 'Get targeted feedback on delivery and structure.' },
          { title: 'Objection Handling', href: '/objection-handling-training', desc: 'Practice real objections with roleplay and samples.' },
          { title: 'Sales Frameworks', href: '/sales-frameworks', desc: 'Learn SPIN, Sandler, Challenger, MEDDIC, and more.' },
          { title: 'Roleplay Scenarios', href: '/sales-roleplay-scenarios', desc: 'Run realistic scenarios with instant AI feedback.' }
        ].map((g) => (
          <div key={g.title} className="rounded-lg border p-4">
            <h3 className="font-medium">{g.title}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{g.desc}</p>
            <div className="mt-3">
              <Link to={g.href} className="text-primary underline">Read more</Link>
            </div>
          </div>
        ))}
      </section>

      <footer className="mt-10 border-t pt-6">
        <p className="font-medium">Jump into practice</p>
        <ul className="mt-2 list-disc pl-6">
          <li><Link to="/app/daily-drill" className="underline">Try a Daily Drill</Link></li>
          <li><Link to="/app/objection-dojo" className="underline">Handle Objections</Link></li>
          <li><Link to="/app/mega-trainer" className="underline">Open Mega Trainer</Link></li>
        </ul>
      </footer>
    </main>
  );
}
